import { useMemo } from "react";
export var useDotPosition = function(param) {
    var slideIndex = param.slideIndex, index = param.index, numberOfDots = param.numberOfDots, distanceFromActive = param.distanceFromActive;
    return useMemo(function() {
        if (numberOfDots < 6) {
            return index - (numberOfDots - 1) / 2;
        }
        var lastIndex = numberOfDots - 1;
        if (slideIndex >= 2 && slideIndex <= lastIndex - 2) {
            return Math.max(-2, Math.min(2, distanceFromActive));
        }
        if (slideIndex < 2) {
            return Math.max(-2, Math.min(2, index - 2));
        }
        return Math.max(-2, Math.min(2, index - lastIndex + 2));
    }, [
        slideIndex,
        index,
        numberOfDots,
        distanceFromActive
    ]);
};
